import React from "react"
import { DeliveryOrderMetadata } from "@/api/adHocCommands"
import { Route2g } from "@/reducers/routes2gSlice"
import { Element } from "@xmpp/xml"

export type DriverContext = {
  routeJid: string | undefined
  upsertRoute2g: (
    route: Route2g,
    routeJid: string,
    options?: {
      useLatLon?: boolean
      sendRouteHandle?: boolean
      orderMetadata?: DeliveryOrderMetadata
    },
  ) => Promise<Element>
  clearRoute2g: (routeJid: string) => Promise<Element>
  addRouteStop: (
    address: string,
    routeJid: string,
    msgId: string,
  ) => Promise<Element>
  highlightDuplicateStop: React.MutableRefObject<
    ((stopId: string) => void) | null
  >
}

export const DriverContext = React.createContext({} as DriverContext)
